import React from 'react';
import { Router } from '@reach/router';
import PropTypes from 'prop-types';
import { WtUi } from 'wt-ui';
import { useTranslation } from 'react-i18next';

import Main from '../Main';
import ErrorBoundary from '../../components/ErrorBoundary';
import VariationContext from '../../services/VariationContext';

// we need to initialize our i18n module
// eslint-disable-next-line no-unused-vars
import i18n from '../../translations/i18n';
import newrelic from './newrelic';
import heap from './heap';

newrelic.init();

const App = ({ configVariation }) => {
  const { i18n: _i18n } = useTranslation();
  const siteCoreLang = (window.performanceApp && window.performanceApp.isoCode) || 'en-GB';
  _i18n.changeLanguage(siteCoreLang);

  if (configVariation === 'embedded') {
    heap.init();
    heap.track('LoadPP');
  }

  return (
    <WtUi>
      <ErrorBoundary>
        <VariationContext.Provider value={configVariation}>
          <Router>
            <Main path="*" />
          </Router>
        </VariationContext.Provider>
        <span data-version={process.env.REACT_APP_VERSION} />
        <span data-commit-hash={process.env.REACT_APP_COMMIT_HASH} />
      </ErrorBoundary>
    </WtUi>
  );
};

App.defaultProps = {
  configVariation: 'embedded',
};

App.propTypes = {
  configVariation: PropTypes.string,
};

export default App;
